const initialState = {
    isLoading : true,
    data      : [],
    error     : false,
};

// Error data is not stored in this reducer
const offers = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case 'RATES_AND_OFFERS_REQUEST_START':
        case 'DATA_REQUEST_START':
            return {
                ...state,
                isLoading: true,
            };
        case 'RATES_AND_OFFERS_REQUEST_SUCCESS':
        case 'DATA_REQUEST_SUCCESS':
            return {
                isLoading : false,
                data      : action.payload.offers,
                error     : false,
            };
        case 'RATES_AND_OFFERS_REQUEST_FAILURE':
        case 'DATA_REQUEST_FAILURE':
            return {
                ...state,
                isLoading : false,
                error     : true,
            };
        default:
            return state;
    }
};

export default offers;
